import client from '@/shared/apis/client'
import { NSIPSFormData, NSIPSExportData } from '@/features/internal/types/nsips'
import { NSIPS_CONSTANTS } from '@/constants/nsips'
import { extractFilenameFromHeader } from '@/shared/utils/downloadBlob'

// ========================================
// Types
// ========================================

interface NSIPSExportResult {
  blob: Blob
  filename: string
}

// ========================================
// 内部ユーティリティ
// ========================================

// フロントエンドのデータ形式をAPI形式に変換
const transformFormDataToAPIFormat = (
  formData: NSIPSFormData
): NSIPSExportData => {
  const apiData: NSIPSExportData = {
    patients: [
      {
        patient_code: formData.patientCode,
        patient_kana_name: formData.patientKanaName,
        patient_kanji_name: formData.patientKanjiName,
        gender: formData.gender,
        birth_date: formData.birthDate,
      },
    ],
    usages: [],
    drugs: [],
  }

  // 処方データを変換
  formData.prescriptions.forEach((prescription, rpIndex) => {
    const rpNumber = (rpIndex + 1).toString()

    // 用法データを追加
    apiData.usages.push({
      rp_number: rpNumber,
      usage_name_1: prescription.usage,
      days_or_times: prescription.days,
    })

    // 薬品データを追加
    prescription.drugs.forEach((drug, drugIndex) => {
      apiData.drugs.push({
        rp_number: rpNumber,
        drug_number: (drugIndex + 1).toString(),
        drug_name: drug.name,
        dosage: drug.quantity,
        dosage_unit: drug.unit,
      })
    })
  })

  return apiData
}

// ========================================
// API 関数
// ========================================

/**
 * NSIPS データをエクスポート
 *
 * @param formData - フォームデータ
 * @returns Blob とファイル名
 */
export const exportNSIPSData = async (
  formData: NSIPSFormData
): Promise<NSIPSExportResult> => {
  const apiData = transformFormDataToAPIFormat(formData)

  const response = await client.post('/api/export/nsips/', apiData, {
    responseType: 'blob',
  })

  const blob = new Blob([response.data], { type: 'text/plain' })
  const filename = extractFilenameFromHeader(
    response.headers['content-disposition'],
    NSIPS_CONSTANTS.DEFAULT_FILENAME
  )

  return { blob, filename }
}
